"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
class MaydayAxiosInstance {
    constructor(TokenService, options) {
        this.TokenService = TokenService;
        this.commonHeaders = (options === null || options === void 0 ? void 0 : options.commonHeaders) || {};
    }
    authRequestInterceptor(config) {
        let bearerToken;
        bearerToken =
            config.url === 'auth/refresh' ? this.TokenService.getRefresh() : this.TokenService.get();
        if (bearerToken) {
            const headers = config.headers || {};
            headers.Authorization = `Bearer ${bearerToken}`;
            config.headers = headers;
        }
        return config;
    }
    authErrorResponseInterceptor(client, options, responseError) {
        return __awaiter(this, void 0, void 0, function* () {
            const originalRequest = responseError.config;
            const noRetryHeader = options.noRetryHeader || 'x-no-retry';
            const refreshStatusCode = options.refreshStatusCode || 401;
            if (responseError.response &&
                responseError.response.status === refreshStatusCode &&
                originalRequest.headers[noRetryHeader] !== 'true') {
                responseError.config.headers[noRetryHeader] = 'true';
                const accessToken = yield this.TokenService.refreshToken();
                responseError.config.headers['Authorization'] = 'Bearer ' + accessToken;
                return client(responseError.config);
            }
            return Promise.reject(responseError);
        });
    }
    create(baseURL, options = {}) {
        let headers = Object.assign({}, this.commonHeaders);
        const { headers: optionsHeaders } = options, _options = __rest(options, ["headers"]);
        if (optionsHeaders)
            Object.assign(headers, optionsHeaders);
        const client = axios_1.default.create(Object.assign({ baseURL,
            headers }, _options));
        if (options.skipInterceptors)
            return client;
        client.interceptors.request.use((config) => this.authRequestInterceptor(config), (error) => {
            Promise.reject(error);
        });
        client.interceptors.response.use((response) => response, (error) => this.authErrorResponseInterceptor(client, options, error));
        return client;
    }
}
exports.default = MaydayAxiosInstance;
